import React from 'react';
import img from '../../assets/images/img.png';
import {
  Container,
  WrapCaption,
  Social,
  WrapS,
} from './styles';
import { IconContext } from 'react-icons';
import {
  FaGithub,
  FaLinkedin,
  FaInstagram,
  FaBehance,
  FaTwitter,
} from 'react-icons/fa';

const Contact = () => (
  <Container>
    <WrapCaption>
      <h1>Contact</h1>
      <img src={img} alt="" /> 
    </WrapCaption>
    <WrapS>
      <a>If you want to connect with me Follow me on the social channels below.</a>
      <Social>
        <IconContext.Provider value={{ size: '32px', color: '#9c33ff' }}>
        <a href="https://github.com/biachacon" target="_blank" rel="noopener noreferrer">
          <FaGithub />
        </a>
        <a href="https://linkedin.com/in/bheatrizchacon" target="_blank" rel="noopener noreferrer">
          <FaLinkedin />
        </a>
        <a href="https://instagram.com/biachacondev" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
        <a href="https://twitter.com/biachacondev" target="_blank" rel="noopener noreferrer">
          <FaTwitter />
        </a>
        <a href="https://behance.net/biachacon" target="_blank" rel="noopener noreferrer">
          <FaBehance />
        </a>
      </IconContext.Provider>
      </Social>
    </WrapS>
    
    <h2>Get In Touch</h2>
  
  </Container>
);
export default Contact;